import React from "react";
import HomeCarousel from "../../Herosection/Components/HomeCarousel";
import Cards from "../../Herosection/Components/Cards";
import Testimonial from "../../Herosection/Components/Testimonials";
import "../../index.css";
import About from "../About/About";
import Services from "../Services/Service";
import Faq from "../Faq/Faq";

function Home() {
  return (
    <>
      <div className="my-3">
        <HomeCarousel />
      </div>

      <div className="my-3">
        <About />
      </div>

      {/* MarQuee Cards  */}
      <div className="my-3">
        <Cards />
      </div>

      <div className="my-3">
        <Services showExtras={false}  />
      </div>

      {/* <div className="my-3">
        <Testimonial />
      </div> */}

      <div className="my-3">
        <Faq />
      </div>
    </>
  );
}

export default Home;
